// extracted by mini-css-extract-plugin
module.exports = {"tableTitleCell":"WorkplaceInformation_tableTitleCell__39gJ4","shynar":"WorkplaceInformation_shynar__3Kwv4"};